import React, { Component } from "react";
import { PageHeader, Tag, notification, Space } from "antd";
import { connect } from "react-redux";

import {
  PlusOutlined,
  EditOutlined,
  FireOutlined,
  StopOutlined,
  CheckCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { ButtonItem, SegmentedItem } from "../../../../Components/Items";
import TableItemDinamico from "../../../../Components/TableItemDinamico";
import ModalContacto from "../Components/ModalContacto";
import ModalLead from "../Components/ModalLead";

class ContactosCRM extends Component {
  state = {
    contactos: [],
    loading: false,
    totalRecords: 0,

    // Estados para Modal de Contacto
    modalContactoVisible: false,
    idContactoAEditar: null,
    verDetalleContacto: false,

    // Estados para Modal de Lead
    modalLeadVisible: false,
    contactoSeleccionadoParaLead: null,

    // Estado del filtro  (1=Activos, 0=Inactivos, 2=Todos)
    valorFiltro: 2,
  };

  fetchData = (params) => {
    this.setState({ loading: true });

    axios
      .post(
        "contactos/selectContactos",
        { ...params, empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const contactosMapeados = res.data.data.map((c) => ({
            ...c,
            estado: c.estado === 1,
          }));

          this.setState({
            contactos: contactosMapeados,
            totalRecords: res.data.totalRecords,
          });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch((error) => console.error(error))
      .finally(() => this.setState({ loading: false }));
  };

  abrirCrearLead = (contacto) => {
    this.setState({
      modalLeadVisible: true,
      contactoSeleccionadoParaLead: contacto,
    });
  };

  cerrarModalLead = () => {
    this.setState({
      modalLeadVisible: false,
      contactoSeleccionadoParaLead: null,
    });
  };

  guardarLead = (valores) => {
    console.log("Lead a guardar:", valores);
    notification.success({
      message: "Lead creado exitosamente.",
      description: "El lead ya está disponible en tu tablero.",
    });
    this.cerrarModalLead();
  };

  abrirModalContacto = (contacto = null) => {
    this.setState({
      modalContactoVisible: true,
      idContactoAEditar: contacto ? contacto._id : null,
      verDetalleContacto: false,
    });
  };

  abrirVerDetalleContacto = (contacto) => {
    this.setState({
      modalContactoVisible: true,
      idContactoAEditar: contacto._id,
      verDetalleContacto: true,
    });
  };

  cerrarModalContacto = () => {
    this.setState({
      modalContactoVisible: false,
      idContactoAEditar: null,
      verDetalleContacto: false,
    });
  };

  toggleEstado = (contacto) => {
    const nuevoEstadoBooleano = !contacto.estado;

    axios
      .post(
        "contactos/cambiarEstadoContacto",
        {
          _id: contacto._id,
          estado: nuevoEstadoBooleano,
        },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.onContactoGuardadoExito();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch((error) => console.error(error));
  };

  onContactoGuardadoExito = () => {
    if (this.tableRef) {
      this.tableRef.fetchData();
    }
  };

  atras() {
    this.props.history.goBack();
  }

  render() {
    const columnas = [
      {
        title: "Nombre Completo",
        dataIndex: "nombre",
        buscar: "nombre",
        render: (text, record) => (
          <span
            style={{
              fontWeight: "bold",
              color: record.estado ? "#172b4d" : "#a5adba",
            }}
          >
            {`${record.nombre} ${record.apellidoPaterno} ${record.apellidoMaterno || ""}`}
          </span>
        ),
      },
      {
        title: "Empresa / Cliente",
        dataIndex: ["clienteId", "razonSocial"],
        buscar: "clienteId",
        render: (text, record) => (
          <Tag color="geekblue">{record.clienteId?.razonSocial || "N/A"}</Tag>
        ),
      },
      {
        title: "Teléfono",
        dataIndex: "numero",
        render: (text) => text || "N/A",
      },
      {
        title: "Correo",
        dataIndex: "correo",
        render: (text) =>
          text ? <a href={`mailto:${text}`}>{text}</a> : "N/A",
      },
      {
        title: "Origen",
        dataIndex: "origen",
        render: (text) => (text ? <Tag>{text}</Tag> : "-"),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        render: (estado) =>
          estado ? (
            <Tag color="green">Activo</Tag>
          ) : (
            <Tag color="red">Inactivo</Tag>
          ),
      },
      {
        title: "Acciones",
        dataIndex: "acciones",
        width: 150,
        render: (text, record) => (
          <Space>
            <ButtonItem
              azul
              size="small"
              icon={<EyeOutlined />}
              onClick={() => this.abrirVerDetalleContacto(record)}
              tooltip="Ver detalles del contacto"
            />
            <ButtonItem
              naranja
              size="small"
              icon={<FireOutlined />}
              onClick={() => this.abrirCrearLead(record)}
              disabled={!record.estado}
              tooltip="Crear nuevo lead"
            />
            <ButtonItem
              size="small"
              icon={<EditOutlined />}
              onClick={() => this.abrirModalContacto(record)}
            />
            <ButtonItem
              rojo={record.estado}
              verde={!record.estado}
              size="small"
              icon={record.estado ? <StopOutlined /> : <CheckCircleOutlined />}
              onClick={() => this.toggleEstado(record)}
            />
          </Space>
        ),
      },
    ];

    return (
      <div style={{ padding: "0 20px" }}>
        <PageHeader
          title="Directorio de Contactos (CRM)"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 15,
          }}
          extra={
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {window.innerWidth > 1000 && (
                <>
                  <SegmentedItem
                    options={[
                      { label: "Activos", value: 1 },
                      { label: "Inactivos", value: 0 },
                      { label: "Todos", value: 2 },
                    ]}
                    onChange={(value) => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ estado: value });
                      }
                      this.setState({ valorFiltro: value });
                    }}
                    value={this.state.valorFiltro}
                  />
                  <div
                    style={{
                      borderLeft: "1px solid #d9d9d9",
                      height: "24px",
                      margin: "0 5px",
                    }}
                  ></div>
                </>
              )}
              <ButtonItem
                key="1"
                className="botonAgregar"
                azul
                icon={<PlusOutlined />}
                onClick={() => this.abrirModalContacto()}
              >
                Nuevo Contacto
              </ButtonItem>
            </div>
          }
          onBack={this.atras.bind(this)}
        />

        <TableItemDinamico
          onRef={(node) => (this.tableRef = node)}
          columns={columnas}
          dataSource={this.state.contactos}
          loading={this.state.loading}
          totalRecords={this.state.totalRecords}
          onFetchData={this.fetchData}
          rowKey="_id"
        />

        <ModalContacto
          visible={this.state.modalContactoVisible}
          onCancel={this.cerrarModalContacto}
          onSuccess={this.onContactoGuardadoExito}
          idContacto={this.state.idContactoAEditar}
          verDetalle={this.state.verDetalleContacto}
        />

        <ModalLead
          visible={this.state.modalLeadVisible}
          onCancel={this.cerrarModalLead}
          onSave={this.guardarLead}
          leadAEditar={null}
          contactosMock={this.state.contactos}
          contactoPreseleccionado={this.state.contactoSeleccionadoParaLead}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ContactosCRM);
